<ng-container *ngIf="datos.opcion == 'editar'">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h2 mat-dialog-title>{{datos.tituloModal|translate}}</h2>
    <button mat-raised-button color="accent" (click)="abreModalImgHtml()">
      {{'EDITOR.ELEMENTOS.BOTONES.ADDIMG' | translate}}
      <mat-icon class="ml-20">add_a_photo</mat-icon>
    </button>
  </div>
  <mat-dialog-content class="mat-typography">
    <ng-container *ngIf="!editorCargado">
      <div fxLayout="column" class="p-20" fxLayoutAlign="space-between center" >
        <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
        <h1>{{'EDITOR.CARGANDO'|translate}}</h1>
      </div>
    </ng-container>
    <editor apiKey="u44q4mabn60a95px2uqtgyeiml3ymlovuzb7ifgfgiwu1q34" *ngIf="editorCargado" [(ngModel)]="datos.texto" #editorMce [init]="opciones" (onChange)="revisaCambios()"></editor>
  </mat-dialog-content>
  <div mat-dialog-actions align="end">
    <button mat-raised-button color="accent" class="mt-20" (click)="salir(2)">
      {{'EDITOR.ELEMENTOS.BOTONES.CANCELAR' | translate}}
      <mat-icon class="ml-20">clear</mat-icon>
    </button>
    <button *ngIf="botGuardar" mat-raised-button color="primary" class="mt-20 dialog_confirmar" (click)="salir(1)" cdkFocusInitial>
      {{'EDITOR.ELEMENTOS.BOTONES.GUARDAR' | translate}}
      <mat-icon class="ml-20">done</mat-icon>
    </button>
  </div>
</ng-container>
<ng-container *ngIf="datos.opcion == 'configAdicional'">
  <h2 mat-dialog-title>{{'EDITOR.CONFIGADICIONAL.TITULO' | translate}}</h2>
  <mat-dialog-content class="mat-typography">
    <ng-container *ngIf="cargandoConfig; else confCargada">
      <div fxLayout="column" class="p-20" fxLayoutAlign="space-between center" >
        <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
        <h1>{{'EDITOR.CARGANDO'|translate}}</h1>
      </div>
    </ng-container>
    <ng-template #confCargada>
      <div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="100">
        <h3>{{'EDITOR.CONFIGADICIONAL.SUBTITULO' | translate}}</h3>
        <p>{{'EDITOR.CONFIGADICIONAL.DISPONIBLES' | translate}}</p>
        <mat-list>
          <mat-list-item *ngFor="let control of controlesAdicionales; let i = index; let last = last;">
            <div class="w100" fxLayout="row" fxLayoutAlign="space-between center">
              <p>{{'EDITOR.CONFIGADICIONAL.CONTROLES.' + control.nombre | translate}}</p>
              <mat-slide-toggle [(ngModel)]="controlesAdicionales[i].activo" (change)="cambioConfiguracion(i)"></mat-slide-toggle>
            </div>
            <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
          </mat-list-item>
        </mat-list>
      </div>
    </ng-template>
  </mat-dialog-content>
  <div mat-dialog-actions align="end">
    <button mat-raised-button color="accent" class="mt-20" (click)="salir(2)">
      {{'EDITOR.ELEMENTOS.BOTONES.REGRESAR' | translate}}
      <mat-icon class="ml-20">clear</mat-icon>
    </button>
  </div>
</ng-container>
